import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Box, ButtonBase, Typography} from 'views/components';
import {Translate, translate} from 'views/module';

const FilterBar = (props) => {
  const {
    selection,
    updateFilter,
    onClearFilter,
    onTogglePrioritySort,
    filterOptions,
  } = props;

  const statusFilter = filterOptions?.status;
  const selectedStatus = selection?.filter?.status?.optionSelected ?? 'ACTIVE';
  const sortByPriority = !!selection?.sortByPriority;
  const isDefaultSelection = selectedStatus === 'ACTIVE' && sortByPriority;
  const statusMap = translate('career.Status');
  const options = React.useMemo(() => {
    return Object.values(statusFilter?.options ?? {}).sort((a, b) => a.rank - b.rank);
  }, [statusFilter]);

  if (!statusFilter) {
    return null;
  }

  return (
    <Box
      sx={{
        width: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          alignContent: 'flex-start',
          width: '100%',
          gap: '12px 8px',
        }}
      >
        <Typography
          sx={{
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '14px',
            color: '#6B6760',
            whiteSpace: 'nowrap',
          }}
        >
          {translate('career.dashboard.JobListings.Filter.Status')}
        </Typography>
        <Box
          sx={{
            width: '1px',
            minWidth: '1px',
            height: '25px',
            backgroundColor: '#E8E4DE',
          }}
        />
        {
          options.map((option) => {
            const isSelected = option.key === selectedStatus;
            const selectedColors = statusMap[option.key] ?? statusMap.INACTIVE;

            return (
              <ButtonBase
                key={option.key}
                onClick={() => updateFilter(statusFilter, option)}
                sx={{
                  'display': 'flex',
                  'alignItems': 'center',
                  'justifyContent': 'center',
                  'px': '9px',
                  'py': '4px',
                  'borderRadius': '20px',
                  'border': `1px solid ${isSelected ? selectedColors.ColorBorder : '#E8E4DE'}`,
                  'backgroundColor': isSelected ? selectedColors.Color : '#F9F8F6',
                  'whiteSpace': 'nowrap',
                  'transition': 'box-shadow 0.2s ease, background-color 0.2s ease, border-color 0.2s ease',
                  '&:hover': {
                    boxShadow: '0px 0px 0px 3px rgba(218, 121, 85, 0.12)',
                  },
                }}
              >
                <Typography
                  sx={{
                    fontFamily: 'Geist Mono',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    fontSize: '14px',
                    lineHeight: '14px',
                    color: isSelected ? selectedColors.ColorText : '#6B6760',
                  }}
                >
                  {option.label}
                </Typography>
              </ButtonBase>
            );
          })
        }
        {
          selectedStatus === 'ACTIVE' &&
          <ButtonBase
            onClick={() => onTogglePrioritySort(!sortByPriority)}
            sx={{
              'display': 'flex',
              'alignItems': 'center',
              'justifyContent': 'center',
              'px': '9px',
              'py': '4px',
              'borderRadius': '20px',
              'border': `1px solid ${sortByPriority ? '#EBBDAD' : '#E8E4DE'}`,
              'backgroundColor': sortByPriority ? '#FFF7F4' : '#F9F8F6',
              'whiteSpace': 'nowrap',
              'transition': 'box-shadow 0.2s ease, background-color 0.2s ease, border-color 0.2s ease',
              '&:hover': {
                boxShadow: '0px 0px 0px 3px rgba(218, 121, 85, 0.12)',
              },
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Geist Mono',
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '14px',
                color: sortByPriority ? '#DA7955' : '#6B6760',
              }}
            >
              {translate('career.dashboard.JobListings.Sort.Priority')}
            </Typography>
          </ButtonBase>
        }
        <Box
          sx={{
            width: '1px',
            minWidth: '1px',
            height: '25px',
            backgroundColor: '#E8E4DE',
          }}
        />
        <ButtonBase
          onClick={onClearFilter}
          sx={{
            'display': 'flex',
            'alignItems': 'center',
            'justifyContent': 'center',
            'px': '9px',
            'py': '4px',
            'borderRadius': '20px',
            'border': '1px solid #E8E4DE',
            'backgroundColor': isDefaultSelection ? '#F9F8F6' : '#FFF7F4',
            'whiteSpace': 'nowrap',
            'transition': 'box-shadow 0.2s ease, background-color 0.2s ease, border-color 0.2s ease',
            '&:hover': {
              boxShadow: '0px 0px 0px 3px rgba(218, 121, 85, 0.12)',
            },
          }}
        >
          <Typography
            sx={{
              fontStyle: 'normal',
              fontWeight: 400,
              fontSize: '14px',
              lineHeight: '14px',
              color: isDefaultSelection ? '#6B6760' : '#DA7955',
            }}
          >
            <Translate expression='generic.ClearAllFilters' />
          </Typography>
        </ButtonBase>
      </Box>
    </Box>
  );
};

FilterBar.propTypes = {
  selection: PropTypes.object.isRequired,
  filterOptions: PropTypes.object.isRequired,
  updateFilter: PropTypes.func.isRequired,
  onClearFilter: PropTypes.func.isRequired,
  onTogglePrioritySort: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(FilterBar));
